import { render, staticRenderFns } from "./CommentEditor.vue?vue&type=template&id=1315e589"
import script from "./CommentEditor.vue?vue&type=script&lang=js"
export * from "./CommentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports